// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 568px) {\n.details-item.with-values {\n    flex-direction: column;\n}\n.row .details-item.with-values .details-label,\n  .row .details-item.with-values .details-value {\n    width: 100%;\n    margin: 0;\n    padding: 0 0.5rem;\n}\n.row .details-item.with-values .details-value {\n    font-weight: bold;\n    padding-bottom: 0.25rem;\n}\n}\n", ""]);
// Exports
module.exports = exports;
